import React from "react";
import { Rule } from "./api";
export function CleaningLevels({ rules }: { rules: Rule[] }) {
  return (
    <>
      {rules
        .filter((rule) => !rule.retired)
        .map((rule) => (
          <article className="hk-paper-level" key={rule.id}>
            <h2>
              <span className="hk-paper-code">{rule.code}</span> {rule.label}
            </h2>
            <p>{rule.description}</p>
          </article>
        ))}
    </>
  );
}
